/* eslint-disable @next/next/no-img-element */
'use client'
import { Image } from '@/components/common'
import { useLogout } from '@/features/auth'
import Link from '@/features/ref/components/Link'
import { useAccountStore } from '@/store/accounts'
import { getTheImageUrl, getVND } from '@/utils/helpers'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import { Avatar, Box, Chip, Divider, Link as MuiLink, Stack, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { useTranslations } from 'next-intl'
import { usePathname } from 'next/navigation'
import { accountMenuList } from './menu.config'
interface MenuActionProps {
  data?: ICustomerInfo
}

export const MenuAction = ({}: MenuActionProps) => {
  const pathName = usePathname()
  const { data } = useAccountStore()
  const t = useTranslations('UserProfile')
  const { logout: handleLogout } = useLogout()
  const tMenu = useTranslations('MenuAccount')

  const listMenu = accountMenuList

  return (
    <Box component="aside">
      <Typography
        mb={2}
        sx={{
          textTransform: 'uppercase',
          fontWeight: 600,
          fontSize: 24,
        }}
      >
        {t('Tài khoản')}
      </Typography>
      <Box display="flex" alignItems="center" gap={0.1} mb={2}>
        <Box minWidth={56} maxWidth={56} flexShrink={0}>
          <Avatar src={getTheImageUrl(data?.profile_picture || '')} sx={{ width: 48, height: 48 }}></Avatar>
        </Box>
        <Box display="flex" flexDirection="column">
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography fontWeight={600}>{data?.lastname} </Typography>
            <Image
              sx={{ width: { xs: '5rem', lg: '6rem' }, display: 'inline-block' }}
              src={getTheImageUrl(data?.affiliate_information?.image)}
              alt="Huy hiệu cấp độ affiliate"
              slotProps={{ img: { style: { display: 'block' } } }}
            />
          </Stack>
          {/* <Tooltip placement="bottom" title={t('Account.feature-in-progress')}> */}
          <Box display="flex" alignItems="center" gap={0.5}>
            <img src="/assets/images/ic-price.png" alt="Xu tích lũy" className="w-[1em] flex-shrink-0" />
            <span>{getVND(data?.affiliate_information?.total_wallet_money, ' ')} xu</span>
          </Box>
        </Box>
      </Box>

      <Box display="flex" flexDirection="column">
        {listMenu.map((el) => {
          // Xử lý pathName không có dấu '/' ở cuối để so sánh chính xác
          const normalizePath = (path: string) =>
            path.endsWith('/') && path.length > 1 ? path.slice(0, -1) : path
          const isActive = normalizePath(pathName) === el.path
          const isComingSoon = (el as any)?.isCommingSoon

          return (
            <Box key={el.path} sx={{ position: 'relative', mb: 1 }}>
              <MuiLink
                component={Link}
                display="flex"
                gap={2}
                alignItems="center"
                justifyContent="space-between"
                px={2}
                py={1.5}
                sx={{
                  color: isComingSoon ? 'var(--sub-color)' : isActive ? 'white' : 'var(--sub-color)',
                  backgroundColor: isActive && !isComingSoon ? 'primary.main' : 'transparent',
                  borderRadius: 2,
                  textDecoration: 'none',
                  transition: '0.2s all ease-in-out',
                  fontSize: {
                    xs: 14,
                    xl: 16,
                  },
                  cursor: isComingSoon ? 'not-allowed' : 'pointer',
                  opacity: isComingSoon ? 0.6 : 1,
                  pointerEvents: isComingSoon ? 'none' : 'auto',
                  '&:hover': isComingSoon ? {} : { backgroundColor: 'primary.main', color: 'white' },
                }}
                href={el.path}
              >
                <Box display="flex" gap={2} alignItems="center">
                  {el.icon}
                  <span>{tMenu(el.label)}</span>
                </Box>
                {/* Hiển thị tag Coming Soon */}
                {isComingSoon && (
                  <Chip
                    label="Coming Soon"
                    size="small"
                    variant="outlined"
                    sx={{
                      height: 20,
                      fontSize: '0.7rem',
                      fontWeight: 600,
                      borderColor: 'warning.main',
                      color: 'warning.main',
                    }}
                  />
                )}
              </MuiLink>
            </Box>
          )
        })}
        <Divider sx={{ mt: 1, mb: 0 }} />
        <Box
          display="flex"
          gap={1}
          alignItems="center"
          px={2}
          py={1.5}
          mt={1}
          sx={{
            color: 'var(--sub-color)',
            cursor: 'pointer',
            fontSize: 16,
            borderRadius: 2,
            '&:hover': {
              backgroundColor: (theme) => alpha(theme.palette.error.main, 0.1),
              color: 'error.main',
            },
          }}
          onClick={handleLogout}
        >
          <LogoutOutlinedIcon />
          <span>{t('Đăng xuất')}</span>
        </Box>
      </Box>
    </Box>
  )
}
